import React, { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import { useNavigate } from "react-router";
import { getAuthenticated, getUserData } from '../../utils/LocalStorage';

import { get, put, del, post } from '../../utils/Api';
import { formatarData } from '../../utils/Formatters';
import DocumentosToolbar from '../../toolbars/DocumentosToolbar';
import ConfirmDialog from '../../dialogs/ConfirmDialog';
import DocumentoDialog from '../../dialogs/DocumentoDialog';

import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';

import { exportar } from '../../utils/Exportar';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ClearIcon from '@mui/icons-material/Clear';

import StaticBox from '../../utils/StaticBox';

import logo_menu from '../../assets/logo-menu.png';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#1565c0',
    color: theme.palette.common.white,
  },
}));

export const DRAWER_WIDTH = 240;

let headCells = [
  {
    id: 'documento_nome',
    label: 'Nome do Documento',
  },
  {
    id: 'documento_nome_cliente',
    label: 'Cliente',
  },
  {
    id: 'situacao_nome',
    label: 'Situação',
  },
  {
    id: 'modelo_resumo',
    label: 'Tipo',
  },
  {
    id: 'usuario_nome_social',
    label: 'Criado por',
  },
  {
    id: 'data_criacao',
    label: 'Criado em',
  },
  {
    id: 'escritorio_nome',
    label: 'Escritório',
  },
];

const defaultEmptyMessage = 'Não há documentos cadastrados!';

function EnhancedTableHead(props) {
  return (
    <>
      <TableHead
        sx={{
          display: { xs: 'none', sm: 'table-header-group' },
        }}>
        <TableRow>
          <StyledTableCell padding="checkbox" />
          {headCells.filter(entry => (entry.id !== 'escritorio_nome' || props.usuarioRoot)).map((headCell) => (
            <StyledTableCell
              key={headCell.id}
            >
              <Typography>
                {headCell.label}
              </Typography>
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>

      <TableHead
        sx={{
          display: { xs: 'table-header-group', sm: 'none' },
        }}>
        <TableRow>
          <StyledTableCell
            key={headCells[0].id}
          >
            <Typography>
              {headCells[0].label}
            </Typography>
          </StyledTableCell>
        </TableRow>
      </TableHead>
    </>
  );
}

export default function Documentos({
  setLoading,
  handleMessage,
  mainError,
  setError,
  version,
  mobileOpen,
  setMobileOpen,
  ...props
}) {
  const navigate=useNavigate();

  const { window } = props;
  const container = window !== undefined ? () => window().document.body : undefined;

  const [refresh,setRefresh] = useState(crypto.randomUUID());

  const [selected, setSelected] = useState('');
  const [situacaoNome, setSituacaoNome] = useState('');
  const [documentos, setDocumentos] = useState([]);
  const [documentosFiltrados, setDocumentosFiltrados] = useState([]);
  const [usuarioAdministrador, setUsuarioAdministrador] = useState(false);
  const [usuarioRoot,setUsuarioRoot] = useState(false);

  const getUsuarioUUID = (callback) => {
    getAuthenticated((usuario)=>{
      callback(usuario.usuario_uuid);
    });
  };

  const handleCloseDrawer = () => {
    setSelected('');
    setSituacaoNome('');
    setMobileOpen(false);
  };

  const [openConfirmDialog, setOpenConfirmDialog] = React.useState(false);

  const handleCloseDialog = () => {
    setOpenConfirmDialog(false);
  };

  const clear = () => {
    setSelected('');
    setSituacaoNome('');
    setMobileOpen(false);
    setRefresh(crypto.randomUUID());
  };

  const handleAgreeDialog = () => {
    setOpenConfirmDialog(false);

    if (mainError) { return; }
    setLoading(true);

    del(`api/documento/${selected}`,{},(json,message,severity)=>{
      clear();
      setLoading(false);
      handleMessage('Documento excluído com sucesso!',severity,'',false);
    },(error,message,severity)=>{
      setLoading(false);
      handleMessage(message,severity,error,true);
    });
  };

  const handleRevisarDocumento = (callback) => {
    if (mainError) { return; }
    setLoading(true);

    put(`api/documento/${selected}/revisar`,{},(json,message,severity)=>{
      clear();
      handleMessage('Documento revisado com sucesso!',severity,'',false);
      setLoading(false);
    },(error,message,severity)=>{
      setLoading(false);
      handleMessage(message,severity,error,true);
      callback();
    });
  };

  const [openDocumentoDialog, setOpenDocumentoDialog] = React.useState(false);

  const handleCloseDocumentoDialog = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    setOpenDocumentoDialog(false);
  };

  const handleAbrirCampos = (json) => {
    setOpenDocumentoDialog(false);

    if (mainError) { return; }
    setLoading(true);

    getUsuarioUUID((uuid)=>{
      json.usuario_uuid = uuid;

      post(`api/documento`,json,(documento)=>{
        clear();
        setLoading(false);
        navigate(`/documento/${documento.documento_uuid}`);
      },(error,message,severity)=>{
        setLoading(false);
        handleMessage(message,severity,error,true);
      });
    });
  };

  const handleSearch = (event) => {
    setSelected('');
    setSituacaoNome('');
    let filtro = event.target.value;
    setDocumentosFiltrados(documentos.filter(
      documento => documento.documento_nome.toLowerCase().includes(filtro.toLowerCase()) ||
      documento.documento_nome_cliente.toLowerCase().includes(filtro.toLowerCase()) ||
      documento.modelo_resumo.toLowerCase().includes(filtro.toLowerCase()) ||
      documento.situacao_nome.toLowerCase().includes(filtro.toLowerCase())
    ));
  };

  useEffect(()=>{
    if (mainError) { setLoading(false); return; }

    const closeDrawer = () => {
      setSelected('');
      setSituacaoNome('');
      setMobileOpen(false);
    };

    getUserData((administrador,root)=>{
      setUsuarioAdministrador(administrador);
      setUsuarioRoot(root);

      get('api/documentos',(json)=>{
        setDocumentos(json.documentos);
        setDocumentosFiltrados(json.documentos);

        // Temporario para adaptar tokens ao escritorio
        /*
        if ( (escritorio_uuid === undefined) || (escritorio_uuid === null) || (escritorio_uuid === '') ) {
          if ( (json.escritorios === undefined) || (json.escritorios === null) || (json.escritorios.length > 0) ) {
            setEscritorioUUID(json.escritorios[0].escritorio_uuid);
          }
        }
        */

        setLoading(false);
        closeDrawer();
      },(error,message,severity)=>{
        handleMessage(message,severity,error,true);
      });

    });
  },[refresh]);

  const handleClick = (event, id, situacao) => {
    if (id === selected) {
      setSelected('');
      setSituacaoNome('');
      setMobileOpen(false);
    } else {
      setSelected(id);
      setSituacaoNome(situacao);
      setMobileOpen(true);
    }
  };

  return (
    <React.Fragment>
      <ConfirmDialog
        openConfirmDialog={openConfirmDialog}
        handleCloseDialog={handleCloseDialog}
        handleAgreeDialog={handleAgreeDialog}
        title={"Aviso"}
        message={"Deseja excluir este documento?"}
        disagree={"Voltar"}
        agree={"Excluir"}
      />

      <DocumentoDialog
        openDocumentoDialog={openDocumentoDialog}
        handleCloseDocumentoDialog={handleCloseDocumentoDialog}
        handleAbrirCampos={handleAbrirCampos}
        setLoading={setLoading}
        handleMessage={handleMessage}
      />

      <StaticBox
        version={version}
        setLoading={setLoading}
        handleMessage={handleMessage}
        error={mainError}
        setError={setError}>
        <React.Fragment>
          <DocumentosToolbar
            selected={selected}
            situacaoNome={situacaoNome}
            handleSearch={handleSearch}
            setOpenConfirmDialog={setOpenConfirmDialog}
            setOpenDocumentoDialog={setOpenDocumentoDialog}
            handleRevisarDocumento={handleRevisarDocumento}
          />
          <TableContainer component={Paper} sx={{ height: '96%' }}>
            <Table
              sx={{ minWidth: { xs: 0, sm: 750 } }}
              aria-labelledby="tableTitle"
              size={'medium'}
            >
              <EnhancedTableHead usuarioRoot={usuarioRoot} />
              <TableBody>
                {
                  (documentosFiltrados.length === 0) ? (
                    <TableRow>
                      <TableCell
                        colSpan={(usuarioRoot) ? 8 : 7}
                        align="center"
                        sx={{
                          display: { xs: 'none', sm: 'table-cell' },
                        }}>
                        {defaultEmptyMessage}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          display: { xs: 'table-cell', sm: 'none' },
                        }}>
                        {defaultEmptyMessage}
                      </TableCell>
                    </TableRow>
                  ) : (
                    documentosFiltrados.map((row, index) => {
                      const isItemSelected = (selected === row.documento_uuid);
                      const labelId = `enhanced-table-checkbox-${index}`;

                      return (
                        <TableRow
                          hover
                          onClick={(event) => handleClick(
                            event,
                            row.documento_uuid,
                            row.situacao_nome,
                          )}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={row.documento_uuid}
                          selected={isItemSelected}
                          sx={{ cursor: 'pointer' }}
                        >
                          <TableCell padding="checkbox"
                            sx={{ display: { xs: 'none', sm: 'table-cell' } }}>
                            <Checkbox
                              color="primary"
                              checked={isItemSelected}
                            />
                          </TableCell>
                          <TableCell
                            component="th"
                            id={labelId}
                            scope="row"
                          >
                            <Typography component="span" sx={{
                              display: 'inline-block',
                              lineHeight: { xs: '40px', sm: '0' },
                            }}>
                              {row.documento_nome}
                            </Typography>
                            {
                              (usuarioRoot) ? (
                                <Chip
                                  label={row.escritorio_nome}
                                  color={'azul'}
                                  sx={{ ml: '10px', mb: '5px', display: { xs: 'inline-flex', sm: 'none' } }}
                                />
                              ) : (<></>)
                            }
                            <Chip
                              label={row.situacao_nome}
                              color={row.situacao_variavel}
                              sx={{ ml: '10px', mb: '5px', display: { xs: 'inline-flex', sm: 'none' } }}
                            />
                          </TableCell>
                          <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{row.documento_nome_cliente}</TableCell>
                          <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}><Chip label={row.situacao_nome} color={row.situacao_variavel} /></TableCell>
                          <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{row.modelo_resumo}</TableCell>
                          <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{row.usuario_nome_social}</TableCell>
                          <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{formatarData(row.data_criacao)}</TableCell>
                          {
                            (usuarioRoot) ? (
                              <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{row.escritorio_nome}</TableCell>
                            ) : (<></>)
                          }
                        </TableRow>
                      );
                    })
                  )
                }

              </TableBody>
            </Table>
          </TableContainer>
        </React.Fragment>
      </StaticBox>

      <Fab
        color="success"
        aria-label="add"
        sx={{
          position: 'absolute',
          bottom: 35,
          right: 35,
          display: { xs: 'flex', sm: 'none' },
        }}
        onClick={()=>{setOpenDocumentoDialog(true)}}>
        <AddIcon />
      </Fab>

      <Box
        component="nav"
        sx={{ width: { sm: DRAWER_WIDTH }, flexShrink: { sm: 0 } }}
        aria-label="mailbox folders">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={()=>{handleCloseDrawer()}}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: DRAWER_WIDTH },
          }}>
          <div>
            <Box
              sx={{
                display: 'block',
                my: 2,
                textAlign: 'center',
              }}>
              <Box
                component="img"
                sx={{ maxWidth: 60, paddingTop: 1 }}
                alt="Logo"
                src={logo_menu}
              />
            </Box>
            <Divider sx={{ display: 'block' }}/>
            <List>

              <ListItem
                key="Editar"
                disablePadding>
                <ListItemButton
                  sx={{ pt: 0.6, pb: 0.6, m: 0 }}
                  onClick={()=>{
                    navigate(`/documento/${selected}`);
                  }}
                >
                  <ListItemIcon sx={{ minWidth: '40px', }}>
                    <EditIcon />
                  </ListItemIcon>
                  <ListItemText primary="Editar" />
                </ListItemButton>
              </ListItem>

              <ListItem
                key="Exportar"
                disablePadding>
                <ListItemButton
                  sx={{ pt: 0.6, pb: 0.6, m: 0 }}
                  onClick={()=>{exportar(selected)}}
                >
                  <ListItemIcon sx={{ minWidth: '40px', }}>
                    <TextSnippetIcon />
                  </ListItemIcon>
                  <ListItemText primary="Exportar" />
                </ListItemButton>
              </ListItem>

              {
                ((situacaoNome !== 'Revisado') && usuarioAdministrador) ? (
                  <ListItem
                    key="Check-Revisado"
                    disablePadding>
                    <ListItemButton
                      sx={{ pt: 0.6, pb: 0.6, m: 0 }}
                      onClick={()=>{
                        handleRevisarDocumento(()=>{
                          handleCloseDrawer();
                        });
                      }}
                    >
                      <ListItemIcon sx={{ minWidth: '40px', }}>
                        <CheckBoxIcon />
                      </ListItemIcon>
                      <ListItemText primary="Revisar" />
                    </ListItemButton>
                  </ListItem>
                ) : (<></>)
              }

              {
                (usuarioAdministrador) ? (
                  <ListItem
                    key="Excluir"
                    disablePadding>
                    <ListItemButton
                      sx={{ pt: 0.6, pb: 0.6, m: 0 }}
                      onClick={()=>{setOpenConfirmDialog(true)}}
                    >
                      <ListItemIcon sx={{ minWidth: '40px', }}>
                        <DeleteIcon />
                      </ListItemIcon>
                      <ListItemText primary="Excluir" />
                    </ListItemButton>
                  </ListItem>
                ) : (<></>)
              }

              <ListItem
                key="Fechar-Menu"
                disablePadding>
                <ListItemButton
                  sx={{ pt: 0.6, pb: 0.6, m: 0 }}
                  onClick={()=>{handleCloseDrawer()}}
                >
                  <ListItemIcon sx={{ minWidth: '40px', }}>
                    <ClearIcon />
                  </ListItemIcon>
                  <ListItemText primary="Fechar Menu" />
                </ListItemButton>
              </ListItem>

            </List>
          </div>
        </Drawer>
      </Box>
    </React.Fragment>
  );
}
